import { render, staticRenderFns } from "./EffectTypes.vue?vue&type=template&id=9534e7e4&"
import script from "./EffectTypes.vue?vue&type=script&lang=js&"
export * from "./EffectTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports